import { render } from "./MathMaterialDetails.vue?vue&type=template&id=29107b18"
import script from "./MathMaterialDetails.vue?vue&type=script&lang=js"
export * from "./MathMaterialDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__